export const paths = {
  home: '/',
  dashboard: '/dashboard',
  partners: '/partner-currency/partners',
  games: '/games',
  currencygames: '/currencygames',
  sessionsForGameCurrency: '/currencygames/sessions-for-gamecurrency',
  sessions: '/partner/partners-currency/sessions',
  sessionEvents: '/partner/partners-currency/players/sessions',
  login: '/login',
  partnerCurrency: '/partner-currency',
  searchplayer: '/searchplayer',
  searchsession: '/searchsession',

};
